var React = require('react');

function CheckIcon (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"28","cy":"28","r":"28","fill":"#F7F7FC","key":0}),React.createElement("path",{"d":"M39.6883 18.0625H36.757C36.1195 18.0625 35.5133 18.3687 35.1383 18.8937L25.3133 32.5188L20.8633 26.3438C20.4883 25.825 19.8883 25.5125 19.2445 25.5125H16.3133C15.907 25.5125 15.6695 25.975 15.907 26.3063L23.6945 37.1063C23.8785 37.363 24.121 37.5722 24.402 37.7166C24.683 37.8609 24.9943 37.9362 25.3102 37.9362C25.626 37.9362 25.9374 37.8609 26.2183 37.7166C26.4993 37.5722 26.7418 37.363 26.9258 37.1063L40.0883 18.8563C40.332 18.525 40.0945 18.0625 39.6883 18.0625Z","fill":"#02CCCB","key":1})]);
}

CheckIcon.defaultProps = {"width":"56","height":"56","viewBox":"0 0 56 56","fill":"none"};

module.exports = CheckIcon;

CheckIcon.default = CheckIcon;
